import React, { useState } from 'react'
import TermsConditionModal from '../components/Components/TermsConditionModal';
import PrivacyPolicyModal from '../components/Components/PrivacyPolicyModal';

const Footer = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const [modalOpenPrivacy, setModalOpenPrivacy] = useState(false);
	var d = new Date();
	return (
		<>
			<div className="footer">
				<div className="copyright">
					<p>© Copyright 2021 ClockMeNow. All Right Reserved.{" "}
						<a href="#" onClick={() => setModalOpenPrivacy(true)}>
							Privacy Policy
						</a>{" "} &amp; <a href="#" onClick={() => setModalOpen(true)}>
							Terms and Condition
						</a>
					</p>
				</div>
			</div>
			<TermsConditionModal open={modalOpen} onClose={() => setModalOpen(false)} />
			<PrivacyPolicyModal open={modalOpenPrivacy} onClose={() => setModalOpenPrivacy(false)} />
		</>
	);
};

export default Footer;
